<div class="account-settings-page">
  <header class="account-settings-page__title-card page-card card border-danger">
    <div class="card-body">
      <h1 class="account-settings-page__title account-settings-page__title--danger d-flex align-items-center gap-2 bw-title-with-info">
        <ion-icon name="trash-outline"></ion-icon>
        Danger zone
        <app-info-tooltip compact placement="right" text="This permanently removes account-owned records and cannot be undone. Confirm with your current password and the word DELETE."></app-info-tooltip>
      </h1>
    </div>
  </header>

  <section class="page-card page-card--danger card border-danger border-2">
    <div class="card-body">
      @if (deleteAccountError) {
        <div class="alert alert-danger">{{ deleteAccountError }}</div>
      }

      <section class="delete-account-page__action" aria-labelledby="delete-account-action-title">
        <h2 id="delete-account-action-title" class="section-title text-danger">Delete account</h2>

        <form (ngSubmit)="deleteAccount()">
          <div class="row g-3">
            <div class="col-md-6">
              <label class="form-label">Current Password</label>
              <input
                type="password"
                class="form-control"
                [(ngModel)]="deleteAccountForm.password"
                name="delete_account_password"
                required
              />
            </div>
            <div class="col-md-6">
              <label class="form-label">Type DELETE to confirm</label>
              <input
                type="text"
                class="form-control"
                [(ngModel)]="deleteAccountForm.confirmation"
                name="delete_account_confirmation"
                placeholder="DELETE"
                required
              />
            </div>
          </div>

          <div class="mt-3 d-flex justify-content-end">
            <button class="btn btn-danger" type="submit" [disabled]="isDeletingAccount">
              @if (!isDeletingAccount) {
                <span>Delete My Account</span>
              } @else {
                <span>Deleting...</span>
              }
            </button>
          </div>
        </form>
      </section>
    </div>
  </section>
</div>
